import { updateObject, } from '../../utils/utility';

const initialState = {
    financialList: [],
    copyOfFinancialList: [],
    totalFinancial: 0,
    pageNumber: 0,
    totalPage: 0,
    companyList: [],
    legalEntityList: [],
    isListRefreshed: false
}

const setMyPaymentsData = (state = initialState, action) => {
    const { financialList = [], totalFinancial, pageNumber, totalPage, companyList = [], legalEntityList = [], paymentStatusList = [], orderTypeList = [] } = action.payload;
    // Fix for SUPP2-5308, Added isCustomerInvoiceNumberDisabled property to identify if Customer Invoice Number is edittable or not.
    const updateFinancialList = [];
    financialList.map(financialData => {
        let isCustomerInvoiceNumberDisabled = false;
        if (financialData.paymentType === 'HP Payment + HP2B' && financialData.paymentStatus === 'HARDWARE_PAYMENT_TO_CUSTOMER_PENDING' && financialData.customerInvoiceNo) {
            isCustomerInvoiceNumberDisabled = true;
        }
        updateFinancialList.push({ ...financialData, isCustomerInvoiceNumberDisabled });
    });

    return updateObject(state, {
        financialList: updateFinancialList,
        totalFinancial,
        pageNumber,
        totalPage,
        companyList,
        legalEntityList,
        paymentStatusList,
        orderTypeList,
        isListRefreshed: true,
        copyOfFinancialList: [...financialList]
    });
};

const updateMyPaymentdata = (state = initialState, action) => {
    const { value, columnName, rowIndex } = action;
    const { financialList } = state;
    financialList[rowIndex] = { ...financialList[rowIndex], [columnName]: value };
    return updateObject(state, { financialList });
}

const reducer = (state = initialState, action) => {
    if (action.type === "SET_MY_PAYMENTS_LIST") {
        return setMyPaymentsData(state, action);
    }
    else if (action.type === "SET_MY_DIRECT_FINANCIALS_LIST") {
        return setMyPaymentsData(state, action);
    }
    else if (action.type === "SET_MY_PARTNER_FINANCIALS_LIST") {
        return setMyPaymentsData(state, action);
    }
    else if (action.type === "SET_MY_INDIRECT_FINANCIALS_LIST") {
        return setMyPaymentsData(state, action);
    }
    else if (action.type === "UPDATE_FINANCIAL_DATA") {
        return updateMyPaymentdata(state, action);
    }
    return state;
}

export default reducer;